let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("1cGGc"), load("h9S5s")]).then(() => parcelRequire('jju36'));